module.exports = __webpack_public_path__ + "img/气泡_3@2x.c1605859.png";